import { render } from "./bulkDeleteModal.vue?vue&type=template&id=31d90416&scoped=true"
import script from "./bulkDeleteModal.vue?vue&type=script&lang=js"
export * from "./bulkDeleteModal.vue?vue&type=script&lang=js"

import "./bulkDeleteModal.vue?vue&type=style&index=0&id=31d90416&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d90416"]])

export default __exports__